import { useMemo } from 'react';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

export const useRutubeVideoLink = (baseUrl: string) => {
  const { config } = useApplicationContext();

  return useMemo(() => {
    const rutubeVideoQueryParams =
      config.get<string>('offerCard.rutubeVideoQueryParams') || /* istanbul ignore next */ '';

    const url = new URL(baseUrl);

    rutubeVideoQueryParams.split('&').forEach(param => {
      const [key, value] = param.split('=');

      url.searchParams.set(key, value);
    });

    return url.toString();
  }, [baseUrl, config]);
};
